import useHistoryStore from '@/store/history';
import { computed } from 'vue';
import { storeToRefs } from 'pinia';

const useHistory = (userUid: string) => {
  const historyStore = useHistoryStore();
  const { isLoading, watchHistories } = storeToRefs(historyStore);

  const history = computed(() => {
    if (watchHistories.value[userUid] === undefined) {
      historyStore.getHistoryTracesByUserUid(userUid);
    }
    return watchHistories.value[userUid];
  });

  return { watchHistory: history, isLoading };
};

export default useHistory;
